import { recordDiagnostic } from "@northstar/dispatch-core";
import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Northstar companion render crashed", error, info.componentStack);
    recordDiagnostic({
      module: "companion-react",
      severity: "error",
      message: error.message || "Companion render crashed",
      stack: `${error.stack ?? ""}\n${info.componentStack ?? ""}`,
    });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="companion-fault" data-testid="companion-error">
        <p className="kicker">Fault</p>
        <h1>Northstar Dispatch Mobile</h1>
        <p className="muted" role="alert">
          {this.state.error.message || "Unknown render error"}
        </p>
        <button type="button" className="btn" onClick={() => this.setState({ error: null })}>
          Try again
        </button>
      </div>
    );
  }
}
